import { render, staticRenderFns } from "./RequestTab.vue?vue&type=template&id=e722945a&scoped=true"
import script from "@/views/Requests/RequestTab/RequestTab.ts?vue&type=script&lang=ts&external"
export * from "@/views/Requests/RequestTab/RequestTab.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Requests/RequestTab/request-tab.scss?vue&type=style&index=0&id=e722945a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e722945a",
  null
  
)

export default component.exports